import React, { ReactElement } from 'react'
import { OwnerOwnerCategoryEnum } from 'api'

import { AvField } from 'availity-reactstrap-validation'
import { Errors, useFormServerErrors } from 'hooks/useFormServerErrors'
import { useTranslation } from 'react-i18next'

export interface Props {
  name: string
  required?: boolean
  serverErrors?: Errors
  onChange?: Function
  disabled?: boolean
  isControlPerson?: boolean
}

export const OwnerTypeSelect = ({
  name,
  required,
  serverErrors,
  disabled = false,
  onChange,
  isControlPerson,
}: Props): ReactElement => {
  const { t } = useTranslation()
  const { handleFieldChange, validate } = useFormServerErrors(serverErrors, (_) => null)
  const handleOnChange = (event) => {
    handleFieldChange(event)
    onChange && onChange(event)
  }
  return (
    <AvField
      name={name}
      label="Select Type"
      placeholder="Select Type"
      type="select"
      disabled={disabled}
      required={required}
      validate={{
        required: {
          value: required,
          errorMessage: t('required_field'),
        },
        async: validate,
      }}
      onChange={handleOnChange}
    >
      <option value={OwnerOwnerCategoryEnum.Individual}>Individual</option>
      <option value={OwnerOwnerCategoryEnum.Entity}>Entity</option>
      {isControlPerson && (
        <option disabled value={OwnerOwnerCategoryEnum.ControlPerson}>
          Control Person
        </option>
      )}
    </AvField>
  )
}
